export default __webpack_public_path__ + "static/media/logo-small.526e355a.png";